export default "__VITE_ASSET__c55bbd56__"